/* ============================================================================
 * WIDE — Simulateur : interface
 * Ne calcule rien. Lit les réglages, appelle le moteur, rend le résultat.
 * ========================================================================= */

(function () {
  'use strict';

  const CONFIG = window.WIDE_CONFIG;
  const ENGINE = window.WIDE_ENGINE;
  const $ = (s) => document.querySelector(s);

  /* --- Formats ---------------------------------------------------------- */
  const euro = (n) => Math.round(n).toLocaleString('fr-FR') + ' €';

  /* Logo inline, pour remplacer le mot « WIDE » dans le texte généré. */
  const LOGO_MOT = '<svg class="mot-wide" role="img" aria-label="WIDE" viewBox="0 0 308.41 70.75"><use href="#logo-wide"></use></svg>';

  /* --- Curseurs : remplissage de piste + échelle min/max ---------------- */
  const formatEchelle = (v, unite) => {
    const n = Number(v);
    const s = Number.isInteger(n) ? n.toLocaleString('fr-FR') : n.toString().replace('.', ',');
    return unite ? `${s} ${unite}` : s;
  };
  function majCurseur(el) {
    const min = Number(el.min) || 0;
    const max = Number(el.max) || 100;
    const pct = max > min ? ((Number(el.value) - min) / (max - min)) * 100 : 0;
    el.style.setProperty('--valeur-pct', pct + '%');

    const echelle = el.parentElement.querySelector(':scope > .echelle');
    if (echelle) {
      const unite = el.dataset.unite || '';
      echelle.children[0].textContent = formatEchelle(min, unite);
      echelle.children[1].textContent = formatEchelle(max, unite);
    }
  }
  function majTousLesCurseurs() {
    document.querySelectorAll('input[type="range"]').forEach(majCurseur);
  }
  /* --- Libellés des postes, dans l'ordre de lecture --------------------- */
  const POSTES = [
    ['apport',                 'Apport'],
    ['fraisNotaire',           'Frais d’acquisition'],
    ['honorairesAgence',       'Honoraires d’agence'],
    ['fraisDossierBancaire',   'Frais de dossier bancaire'],
    ['fraisJuridiques',        'Frais juridiques'],
    ['amenagement',            'Mobilier et travaux'],
    ['rafraichissement',       'Rafraîchissement en cours de bail'],
    ['loyer',                  'Loyer'],
    ['remboursementCapital',   'Remboursement du capital'],
    ['interetsBancaires',      'Intérêts du prêt'],
    ['chargesImmobilieres',    'Charges de l’immeuble'],
    ['servicesOccupants',      'Services aux occupants'],
    ['grosEntretien',          'Gros entretien du bâtiment'],
    ['taxeFonciere',           'Taxe foncière'],
    ['fraisDeGestion',         'Comptabilité de la structure'],
    ['forfaitWide',            'Forfait tout inclus'],
  ];

  /* --- État ------------------------------------------------------------- */
  const etat = {
    localityId: CONFIG.LOCALITIES[0].id,
    collaborators: 10,
    horizon: CONFIG.UI.horizonDefault,
    rentPerSqmYear: null,
    propertyPricePerSqm: null,
    downPaymentRate: 0.20,
    interestRate: 3.5,
    acquisitionRegime: 'neuf',
    vueNette: CONFIG.GLOBAL.showResidualValueByDefault.valeur,
  };

  /* ======================================================================
   * Mise en place des commandes
   * =================================================================== */

  function monterLocalites() {
    const sel = $('#localite');
    sel.innerHTML = CONFIG.LOCALITIES.map(
      (l) => `<option value="${l.id}">${l.name}</option>`
    ).join('');
    sel.value = etat.localityId;
    sel.addEventListener('change', () => {
      etat.localityId = sel.value;
      calerSurLocalite();
      rendre();
    });
  }

  function monterSegments(id, valeurs, cle, format) {
    const zone = $('#' + id);
    zone.innerHTML = valeurs
      .map((v) => `<button type="button" data-valeur="${v}">${format(v)}</button>`)
      .join('');
    zone.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b) return;
      const brut = b.dataset.valeur;
      etat[cle] = isNaN(Number(brut)) ? brut : Number(brut);
      rendre();
    });
  }

  function monterRegime() {
    $('#regime').addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b) return;
      etat.acquisitionRegime = b.dataset.valeur;
      rendre();
    });
  }

  function monterCurseurs() {
    const lier = (id, cle, transforme) => {
      $('#' + id).addEventListener('input', (e) => {
        etat[cle] = transforme ? transforme(Number(e.target.value)) : Number(e.target.value);
        majCurseur(e.target);
        rendre();
      });
    };
    lier('collaborateurs', 'collaborators');
    lier('loyer', 'rentPerSqmYear');
    lier('prix', 'propertyPricePerSqm');
    lier('apport', 'downPaymentRate', (v) => v / 100);
    lier('taux', 'interestRate');
  }

  function monterBascules() {
    $('#b-vue').addEventListener('click', () => { etat.vueNette = !etat.vueNette; rendre(); });
  }

  /* Accordéon « Pourquoi WIDE » : un seul volet ouvert à la fois. */
  function monterAccordeon() {
    const zone = $('#accordeon');
    if (!zone) return;
    const items = [...zone.querySelectorAll('.accordeon-item')];
    zone.addEventListener('click', (e) => {
      const bouton = e.target.closest('.accordeon-question');
      if (!bouton) return;
      const item = bouton.closest('.accordeon-item');
      const ouvert = item.dataset.etat === 'open';
      items.forEach((i) => {
        i.dataset.etat = 'closed';
        i.querySelector('.accordeon-question').setAttribute('aria-expanded', 'false');
      });
      if (!ouvert) {
        item.dataset.etat = 'open';
        bouton.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* Les bornes des curseurs dépendent de la localité choisie. */
  function calerSurLocalite() {
    const loc = CONFIG.resolveConfig(etat.localityId).locality;

    const loyer = $('#loyer');
    loyer.min = loc.rentPerSqmYearMin;
    loyer.max = loc.rentPerSqmYearMax;
    loyer.value = loc.rentPerSqmYearMin;
    etat.rentPerSqmYear = loc.rentPerSqmYearMin;

    const prix = $('#prix');
    prix.min = loc.propertyPricePerSqmMin;
    prix.max = loc.propertyPricePerSqmMax;
    prix.value = loc.propertyPricePerSqmMin;
    etat.propertyPricePerSqm = loc.propertyPricePerSqmMin;

    majTousLesCurseurs();
  }

  /* ======================================================================
   * Rendu
   * =================================================================== */

  function rendre() {
    const r = ENGINE.simulate(etat, CONFIG);
    const cfg = r.config;

    rendreCommandes(r, cfg);
    rendreBarres(r);
    rendreAlertes(r);
    rendreTableau(r);
    rendreHypotheses(cfg);
  }

  function valeur(opt, r) {
    const bloc = etat.vueNette ? opt.net : opt.total;
    return bloc.nominal;
  }

  function rendreCommandes(r, cfg) {
    const loc = cfg.locality;
    const surface = ENGINE.surfaceForCollaborators(etat.collaborators);

    $('#v-collaborateurs').textContent =
      etat.collaborators + (etat.collaborators > 1 ? ' personnes' : ' personne');
    $('#aide-surface').innerHTML =
      `Soit ${surface} m² privatifs, et ${surface + Math.round(surface * loc.wideSharedSurfaceRate)} m² chez ${LOGO_MOT}, espaces mutualisés compris.`;

    $('#v-horizon').textContent = etat.horizon + ' ans';
    $('#v-loyer').textContent = etat.rentPerSqmYear + ' €/m² HT';
    $('#aide-loyer').textContent =
      `Marché local : de ${loc.rentPerSqmYearMin} à ${loc.rentPerSqmYearMax} €/m² HT par an.`;

    $('#v-prix').textContent = etat.propertyPricePerSqm.toLocaleString('fr-FR') + ' €/m² HT';
    $('#aide-prix').textContent =
      `Soit ${euro(etat.propertyPricePerSqm * ENGINE.surfaceForCollaborators(etat.collaborators))} pour ${ENGINE.surfaceForCollaborators(etat.collaborators)} m².`;

    $('#v-apport').textContent = Math.round(etat.downPaymentRate * 100) + ' %';
    $('#v-taux').textContent = etat.interestRate.toFixed(2).replace('.', ',') + ' %';

    $('#aide-regime').textContent =
      etat.acquisitionRegime === 'ancien'
        ? `Droits de mutation et émoluments : ${(cfg.global.notaryFeesRateAncien * 100).toFixed(1).replace('.', ',')} % du prix.`
        : 'Droits réduits. La TVA à 20 % s’ajoute au prix mais reste récupérable si votre société y est assujettie.';

    // États pressés
    document.querySelectorAll('#horizon button').forEach((b) =>
      b.setAttribute('aria-pressed', Number(b.dataset.valeur) === etat.horizon));
    document.querySelectorAll('#regime button').forEach((b) =>
      b.setAttribute('aria-pressed', b.dataset.valeur === etat.acquisitionRegime));

    // Le libellé annonce l'action du clic (la vue vers laquelle on bascule),
    // pas la vue actuellement affichée — plus explicite qu'un état figé.
    const bVue = $('#b-vue');
    bVue.setAttribute('aria-pressed', String(etat.vueNette));
    bVue.querySelector('.bascule-texte').textContent =
      etat.vueNette ? 'Voir l’achat en coût brut' : 'Voir l’achat net de la revente';

    $('#titre-resultat').textContent = `Coût total sur ${etat.horizon} ans`;
  }

  function rendreBarres(r) {
    const lignes = [
      { cle: 'wide',     nom: LOGO_MOT,     opt: r.options.wide },
      { cle: 'location', nom: 'Bail 3-6-9', opt: r.options.location },
      { cle: 'achat',    nom: 'Achat',      opt: r.options.achat },
    ].map((l) => ({ ...l, montant: valeur(l.opt, r) }));

    const max = Math.max(...lignes.map((l) => Math.abs(l.montant))) || 1;
    // La moins chère, recalculée à chaque rendu — jamais assumée pour WIDE.
    const min = Math.min(...lignes.map((l) => Math.abs(l.montant)));

    $('#barres').innerHTML = lignes
      .map((l) => {
        const grandChiffre = l.montant;
        const surfaceTexte = l.cle === 'wide'
          ? `pour <strong>${l.opt.finalSurface} m²</strong>, espaces mutualisés compris`
          : `pour <strong>${l.opt.finalSurface} m²</strong> privatifs`;
        const grandUnite = `sur ${etat.horizon} ans, ${surfaceTexte}`;
        return `
        <li class="barre barre-${l.cle}">
          ${Math.abs(l.montant) === min ? '<span class="barre-badge">La moins chère</span>' : ''}
          <div class="barre-piste">
            <div class="barre-remplissage" style="width:${Math.max(2, (Math.abs(l.montant) / max) * 56)}%">
              <span class="barre-titre">${l.nom}</span>
            </div>
            <span class="barre-chiffre">${euro(grandChiffre)}<span class="barre-unite">${grandUnite}</span></span>
          </div>
        </li>`;
      })
      .join('');

    const ecart = valeur(r.options.location, r) - valeur(r.options.wide, r);
    $('#note-lecture').innerHTML = etat.vueNette
      ? `Le coût de l’achat est net de ce que vaut le bien au terme, soit ${euro(r.options.achat.residualValue)} après frais de revente et remboursement du prêt. Sur ${etat.horizon} ans, l’écart entre le bail et ${LOGO_MOT} atteint ${euro(ecart)}.`
      : `L’achat est ici compté en sorties de trésorerie, capital compris : au terme vous détenez un bien estimé ${euro(r.options.achat.residualValue)}, que cette vue ne déduit pas. Sur ${etat.horizon} ans, l’écart entre le bail et ${LOGO_MOT} atteint ${euro(ecart)}.`;
  }

  function rendreAlertes(r) {
    const zone = $('#alertes');
    const a = [];

    // Alerte masquée pour Chambéry et Valence : gardée pour les autres
    // localités sans site WIDE, désactivée ici à la demande de WIDE.
    const sansAlerteWide = ['chambery', 'valence'];
    if (r.checks.wideIsElsewhere && !sansAlerteWide.includes(r.locality.id)) {
      a.push(`<div class="alerte"><strong>${LOGO_MOT} n’a pas d’espace à ${r.locality.name}.</strong>
        La colonne ${LOGO_MOT} chiffre la même équipe à ${r.locality.wideSite}, à ${r.locality.distanceToWideSiteKm} km
        et ${r.locality.travelTimeToWideSite} de route. Ce déplacement a des conséquences que ce calcul
        n’évalue pas : bassin de recrutement, trajets de vos équipes, proximité de vos clients.</div>`);
    }
    if (r.checks.impliedYieldWarning) {
      a.push(`<div class="alerte"><strong>Ce couple loyer / prix est peu réaliste.</strong>
        Il correspond à un rendement de ${(r.checks.impliedYield * 100).toFixed(1).replace('.', ',')} %,
        en dehors de ce qui s’observe sur ce marché. La comparaison reste calculée, mais elle repose
        sur des hypothèses qu’un agent immobilier contesterait.</div>`);
    }
    zone.innerHTML = a.join('');
  }

  function rendreTableau(r) {
    const cellule = (opt, cle) => {
      const l = opt.lines[cle];
      if (!l) return '<td class="mot">—</td>';
      const v = l.nominal;
      return `<td>${v < 0 ? '− ' + euro(-v) : euro(v)}</td>`;
    };

    const lignes = POSTES.filter(([cle]) =>
      r.options.location.lines[cle] || r.options.achat.lines[cle] || r.options.wide.lines[cle]
    ).map(([cle, nom]) => `
      <tr>
        <th scope="row">${nom}</th>
        ${cellule(r.options.location, cle)}
        ${cellule(r.options.achat, cle)}
        ${cellule(r.options.wide, cle)}
      </tr>`).join('');

    const brut = (o) => o.total.nominal;
    const net = (o) => o.net.nominal;

    const caution = (o) =>
      o.refundable && o.refundable.caution
        ? euro(o.refundable.caution)
        : '<span class="mot">—</span>';

    const residuelle = `
      <tr class="sous-total">
        <th scope="row">Sortie de trésorerie</th>
        <td>${euro(brut(r.options.location))}</td>
        <td>${euro(brut(r.options.achat))}</td>
        <td>${euro(brut(r.options.wide))}</td>
      </tr>
      <tr>
        <th scope="row">Valeur du bien au terme, nette de revente et de prêt</th>
        <td class="mot">—</td>
        <td>− ${euro(r.options.achat.residualValue)}</td>
        <td class="mot">—</td>
      </tr>`;

    $('#corps-tableau').innerHTML = lignes + (etat.vueNette ? residuelle : '') + `
      <tr class="total">
        <th scope="row">Coût sur ${etat.horizon} ans</th>
        <td>${euro(valeur(r.options.location, r))}</td>
        <td>${euro(valeur(r.options.achat, r))}</td>
        <td>${euro(valeur(r.options.wide, r))}</td>
      </tr>
      <tr class="rendue">
        <th scope="row">Dépôt de garantie, restitué en fin de contrat</th>
        <td>${caution(r.options.location)}</td>
        <td class="mot">—</td>
        <td>${caution(r.options.wide)}</td>
      </tr>`;

    $('#chapo-detail').textContent = etat.vueNette
      ? 'Chaque total est exactement la somme de sa colonne. Rien n’est affiché sans être compté.'
      : 'Vue en sorties de trésorerie : le capital remboursé y figure, mais le bien que vous détenez au terme n’est pas déduit.';
  }

  function rendreHypotheses(cfg) {
    const g = cfg.global;
    const loc = cfg.locality;
    const pc = (x) => (x * 100).toFixed(1).replace('.', ',') + ' %';

    const items = [
      ['Charges de l’immeuble', (loc.chargesImmobilieresPerSqmMonthly * 12) + ' €/m²/an'],
      ['Services aux occupants', (loc.servicesOccupantsPerSqmMonthly * 12) + ' €/m²/an'],
      ['Taxe foncière', loc.propertyTaxPerSqmYear + ' €/m²/an'],
      ['Mobilier et travaux', (g.furniturePerSqm + g.worksPerSqm) + ' €/m²'],
      ['Indexation des loyers', pc(g.rentIndexation)],
      ['Indexation des charges', pc(g.chargesIndexation)],
      ['Valorisation du bien', pc(g.propertyAppreciation)],
      [`Poste de travail ${LOGO_MOT}`, loc.wideWorkstationPrice + ' €/mois'],
    ];

    $('#liste-hypotheses').innerHTML = items
      .map(([k, v]) => `<li><span>${k}</span><span>${v}</span></li>`)
      .join('');

  }

  /* ======================================================================
   * Rapport PDF — gabarit hors-écran, capturé en image (html2canvas) puis
   * posé sur une page A4 (jsPDF). Voir le commentaire CSS de .rapport-pdf
   * pour le choix du texte plutôt que du logo <svg><use>.
   * =================================================================== */

  function rapportCarte(cle, nom, surface, lignes, montant) {
    return `
      <div class="rapport-carte rapport-carte-${cle}">
        <div class="rapport-carte-tete">
          <strong>${nom}</strong>
          <span>${surface}</span>
        </div>
        <ul class="rapport-carte-lignes">
          ${lignes.map(([k, v]) => `<li><span>${k}</span><span>${v}</span></li>`).join('')}
        </ul>
        <div class="rapport-carte-total">
          <span class="valeur">${euro(montant)}</span>
          <span class="unite">sur ${etat.horizon} ${etat.horizon > 1 ? 'ans' : 'an'}</span>
        </div>
      </div>`;
  }

  function remplirRapportPDF(r) {
    const surface = ENGINE.surfaceForCollaborators(etat.collaborators);

    const loc = r.options.location;
    const achat = r.options.achat;
    const wide = r.options.wide;

    const montants = {
      location: valeur(loc, r),
      achat: valeur(achat, r),
      wide: valeur(wide, r),
    };

    const ligne = (opt, cle) => (opt.lines[cle] ? euro(opt.lines[cle].nominal) : '—');
    const mensualite = (opt) =>
      euro((opt.lines.remboursementCapital ? opt.lines.remboursementCapital.nominal : 0) +
           (opt.lines.interetsBancaires ? opt.lines.interetsBancaires.nominal : 0));

    $('#rapport-date').textContent =
      new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
      ' à ' + new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

    $('#rapport-titre').textContent = `Acheter, louer ou passer chez WIDE sur ${r.locality.name} ?`;
    $('#rapport-chapo').textContent =
      `Coût comparé sur ${etat.horizon} ${etat.horizon > 1 ? 'ans' : 'an'} pour ${etat.collaborators} ` +
      `${etat.collaborators > 1 ? 'collaborateurs' : 'collaborateur'}, entre bail commercial, achat et forfait WIDE tout inclus.`;

    $('#rapport-cartes').innerHTML =
      rapportCarte('location', 'Bail 3-6-9', `${surface} m² privatifs`, [
        ['Loyer', ligne(loc, 'loyer')],
        ['Charges de l’immeuble', ligne(loc, 'chargesImmobilieres')],
        ['Mobilier et travaux', ligne(loc, 'amenagement')],
        ['Caution, restituée', euro(loc.refundable.caution || 0)],
      ], montants.location) +
      rapportCarte('achat', 'Achat', `${surface} m² privatifs`, [
        ['Apport', ligne(achat, 'apport')],
        ['Mensualités de prêt', mensualite(achat)],
        ['Frais de notaire', ligne(achat, 'fraisNotaire')],
        ['Taxe foncière', ligne(achat, 'taxeFonciere')],
      ], montants.achat) +
      rapportCarte('wide', 'WIDE, tout inclus', `${wide.finalSurface} m², espaces mutualisés compris`, [
        ['Forfait tout inclus', ligne(wide, 'forfaitWide')],
        ['Caution, restituée', euro(wide.refundable.caution || 0)],
      ], montants.wide);

    const ecart = Math.abs(montants.location - montants.wide);
    $('#rapport-ecart').innerHTML =
      `<span class="valeur">${euro(ecart)}</span>` +
      `<span class="unite">d’écart entre le bail et WIDE sur ${etat.horizon} ${etat.horizon > 1 ? 'ans' : 'an'}</span>`;
  }

  async function genererRapportPDF() {
    const bouton = $('#b-pdf');
    const texteInitial = bouton.textContent;
    bouton.disabled = true;
    bouton.textContent = 'Génération…';

    try {
      const r = ENGINE.simulate(etat, CONFIG);
      remplirRapportPDF(r);

      const cible = $('#rapport-pdf');
      const canvas = await html2canvas(cible, { scale: 2, backgroundColor: '#FFFFFF' });

      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF('p', 'pt', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = (canvas.height * pageWidth) / canvas.width;

      pdf.addImage(canvas.toDataURL('image/jpeg', 0.92), 'JPEG', 0, 0, pageWidth, pageHeight);
      pdf.save(`simulation-wide-${etat.localityId}-${new Date().toISOString().slice(0, 10)}.pdf`);
    } catch (err) {
      console.error('Échec de la génération du PDF', err);
      alert('La génération du PDF a échoué. Réessayez.');
    } finally {
      bouton.disabled = false;
      bouton.textContent = texteInitial;
    }
  }

  function monterExportPDF() {
    $('#b-pdf').addEventListener('click', genererRapportPDF);
  }

  /* ======================================================================
   * Démarrage
   * =================================================================== */

  monterLocalites();
  monterSegments('horizon', CONFIG.UI.horizonOptions, 'horizon', (v) => v + ' ans');
  monterRegime();
  monterCurseurs();
  monterBascules();
  monterAccordeon();
  monterExportPDF();
  calerSurLocalite();

  // Préréglage au chargement : valeurs types plutôt que le plancher du marché.
  $('#loyer').value = 160;
  etat.rentPerSqmYear = 160;
  $('#prix').value = 1800;
  etat.propertyPricePerSqm = 1800;

  $('#collaborateurs').value = etat.collaborators;
  $('#apport').value = etat.downPaymentRate * 100;
  $('#taux').value = etat.interestRate;
  majTousLesCurseurs();

  rendre();
})();
